import React from 'react';
import { getTxt } from 'global/appGlobal';
import { Typography } from '@material-ui/core';

const UnderDevScreen = () => <Typography variant="h4" color="inherit" noWrap={false}>{getTxt('Under Development', '#0l71co8')}</Typography>;
export default UnderDevScreen;
